/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recovery_Codes_SectionInputs */

const en_recovery_codes_section = /** @type {(inputs: Recovery_Codes_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recovery codes`)
};

const de_recovery_codes_section = /** @type {(inputs: Recovery_Codes_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederherstellungscodes`)
};

/**
* | output |
* | --- |
* | "Recovery codes" |
*
* @param {Recovery_Codes_SectionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recovery_codes_section = /** @type {((inputs?: Recovery_Codes_SectionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_Codes_SectionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recovery_codes_section(inputs)
	return en_recovery_codes_section(inputs)
});